import React, { useState, useEffect} from 'react';
import './file-thumb.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFile, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { IconoPdf, IconoFileUnknow, IconoDocx } from 'assets/img';
function FileThumb(props) {
    const [elThumb,  setElThumb] = useState(null);
    const armarThump = () => {
        const tipo = props.file && props.file.type ? props.file.type : null;
        let thumb = null;
        switch (tipo) {
            case "image/jpg":
                thumb = <div className="div-thumb" style={{ backgroundImage: `url(${URL.createObjectURL(props.file)})` }}></div>;
                break;
            case "image/jpeg":
                thumb = <div className="div-thumb" style={{ backgroundImage: `url(${URL.createObjectURL(props.file)})` }}></div>;
                break;
            case "image/png":
                thumb = <div className="div-thumb" style={{ backgroundImage: `url(${URL.createObjectURL(props.file)})` }}></div>;
                break;
            case "image/gif":
                thumb = <div className="div-thumb" style={{ backgroundImage: `url(${URL.createObjectURL(props.file)})` }}></div>;
                break;
            case "application/pdf":
                thumb = <img src={IconoPdf} style={{ width: 100 }} alt="Thumb"/>;
                break;
            case "application/docx":
                thumb = <img src={IconoDocx} style={{ width: 100 }} alt="Thumb"/>;
                break;
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                thumb = <img src={IconoDocx} style={{ width: 100 }} alt="Thumb"/>;
                break;
            default:
                thumb = <img src={IconoFileUnknow} style={{ width: 100 }} alt="Thumb"/>;
                break;
        }
        setElThumb(thumb);
    }
    useEffect(() => {
        armarThump();
    }, []);
    useEffect(() => {
        armarThump();
    }, [props.file]);
    return (
        <div className="thumb-file-container" onClick={props.onClick}>
            <div className="div-superior">
                {elThumb}
            </div>
            <div className="bs-bbox">
                <FontAwesomeIcon icon={faCheck} /><br/>
                <span className="label">{props.label}</span>
            </div>
        </div>
    );
}
export default FileThumb;